import { atom, getDefaultStore } from 'jotai';

// Buffered signal for an invite/referral-code capture flow: raised when a
// fresh one-time code is captured (e.g. from a URL parameter), consumed by
// the UI layer that owns the invite-welcome experience. The atom lives in
// jotai's default store — every importer in the JS realm shares it, and
// non-React emitters write through getDefaultStore().
//
// The atom BUFFERS: a code emitted before the consuming surface mounts sits
// in the atom until read. Exactly-once delivery is the CONSUMER'S job: it
// must clear the atom (set null) when it consumes the code, or a remount
// re-consumes the same payload. Emits wrap the code in a fresh object so a
// repeat emit of the SAME code still re-notifies subscribers.
export const inviteCodeAtom = atom<{ code: string } | null>(null);

export function emitInviteCode(code: string): void {
  getDefaultStore().set(inviteCodeAtom, { code });
}

// A buffered code CAN outlive the session that captured it: the default
// store survives client-side navigation, so a code emitted while the
// consuming surface is unmounted sits buffered until the next mount —
// potentially a different person on the same browser. Consumers ending a
// session deliberately must call this, or the pending one-time code is
// silently consumed by the next visitor.
export function clearInviteCodeSignal(): void {
  getDefaultStore().set(inviteCodeAtom, null);
}
